import React, { Component } from 'react';
import classes from './EditResourcesPopup.module.css';
import FlexModal from '../../UI/FlexModal/FlexModal';
import CloseIcon from '../../..//assets/icons/icon-close-black.svg'
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import Tabs from '../../UI/HorizontalTabs/HorizontalTabs';

import UploadResourceFiles from './UploadResourceFiles/UploadResourceFiles';
import UploadResourceVideo from './UploadResourceVideo/UploadResourceVideo';
import UploadSessionRecording from './UploadSessionRecording/UploadSessionRecording';

class EditResourcesPopup extends Component {
    state = {
        tabs: [
            {
                id: 1,
                label: 'Pre-watch videos'
            },
            {
                id: 2,
                label: 'Resource files'
            },
            {
                id: 3,
                label: 'Session Recording'
            },
        ],
        currentTabId: 1,
        loadingData: false,
    }

    onTabClick = (id) => {
        switch (id) {
            case 1: // Overall Performance Tab
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: id });
                } else {
                    this.setState({ currentTabId: id });
                }
                break;
            case 2: // Attendance Tab
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: id });
                } else {
                    this.setState({ currentTabId: id });
                }
                break;
            case 3: // Attendance Tab
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: id });
                } else {
                    this.setState({ currentTabId: id });
                }
                break;
            default:
                if (!this.state.loadingData) {
                    this.setState({ currentTabId: 1, loadingData: true });
                } else {
                    this.setState({ currentTabId: 1 });
                }
                break;
        }
    }

    closeModal = () => {
        this.props.onClose(false);
    }

    render() {
        let tabPos = 0;
        for (let item in this.state.tabs) {
            if (this.state.tabs[item].id === this.state.currentTabId) {
                tabPos = item;
            }
        }

        let renderResults = '';

        switch (parseInt(tabPos, 10)) {
            case 0:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <UploadResourceVideo
                        topicId={this.props.topicId}
                        closeModal={this.closeModal}
                        resourceFiles={this.props.topicData.resources}
                        onUploadSuccessful={this.props.onUploadSuccessful}

                        onSuccessDialogShow={this.props.onSuccessDialogShow}
                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError}
                    />
                }
                break;
            case 1:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults =
                        <UploadResourceFiles
                            topicId={this.props.topicId}
                            closeModal={this.closeModal}
                            resourceFiles={this.props.topicData.resources}
                            onUploadSuccessful={this.props.onUploadSuccessful}

                            onSuccessDialogShow={this.props.onSuccessDialogShow}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                            redirectToUnauthorized={this.props.redirectToUnauthorized}
                            showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                            redirectToNotFound={this.props.redirectToNotFound}
                            redirectToServerError={this.props.redirectToServerError} />
                }
                break;
            case 2:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <UploadSessionRecording
                        liveSessionId={this.props.liveSessionId}
                        topicId={this.props.topicId}
                        closeModal={this.closeModal}
                        resourceFiles={this.props.topicData.resources}
                        onUploadSuccessful={this.props.onUploadSuccessful}
                        getTopicDetails={this.props.getTopicDetails}
                        onSuccessDialogShow={this.props.onSuccessDialogShow}
                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError}
                        isSessionRecording={true} />
                }
                break;

            default:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <UploadResourceVideo
                        topicId={this.props.topicId}
                        closeModal={this.closeModal}
                        resourceFiles={this.props.topicData.resources}
                        onSuccessDialogShow={this.props.onSuccessDialogShow}
                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError}
                        isSessionRecording={false} />
                }
        }

        return (
            <FlexModal visible={true} width={"50%"} >
                <div className={classes.PopupContainer}>
                    <span className={classes.PopupHeading}>Edit Resources
                        <img src={CloseIcon} alt="Close" className={classes.CloseIcon} onClick={this.closeModal} /> </span>

                    <div className={classes.Tabs}>
                        <Tabs
                            tabList={this.state.tabs}
                            onTabClick={this.onTabClick}
                            currentTabId={this.state.currentTabId}
                        />
                    </div>

                    <div className={classes.TabData}>
                        {
                            this.state.showError
                                ? <p>Data not available.</p>
                                : renderResults
                        }
                    </div>
                </div>
            </FlexModal>

        );
    }
}

export default EditResourcesPopup;